angular.module('autoremind.communications')
    .directive('communicationsStrategies', function () {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/communication/forms/communications-strategies.html',
        link: function (scope, elem, attrs, formCtrl) {
            scope.getDestinatorTypeImage = function (destinatorType) {
                var offset = destinatorType.indexOf('voice-');
                if (offset !== -1) {
                    return '/img/icons/media-voice.png';
                }
                offset = destinatorType.indexOf('sms-');
                if (offset !== -1) {
                    return '/img/icons/media-sms.png';
                }
                return '/img/icons/media-email.png';
            };
            // TODO: Consider moving to jobService - if needed elsewhere
            scope.destinatorTypes = [
                { type: '', label: 'None' },
                { type: 'email', label: 'Email' },
                { type: 'sms-phonecell', label: 'Text Message (Cell Phone)' },
                { type: 'sms-phonehome', label: 'Text Message (Home Phone)' },
                { type: 'voice-phonehome', label: 'Voice Call (Home Phone)' },
                { type: 'voice-phonecell', label: 'Voice Call (Cell Phone)' },
                { type: 'voice-phonework', label: 'Voice Call (Work Phone)' },
                { type: 'voice-phonealt', label: 'Voice Call (Alt. Phone)' }
            ];
            scope.destinatorTypesForLatepayment = [
                //{ type: '',           label: 'None' },
                { type: 'email', label: 'Email' },
                { type: 'sms-phonecell', label: 'Text Message (Cell Phone)' },
                { type: 'sms-phonehome', label: 'Text Message (Home Phone)' },
                { type: 'voice-phonehome', label: 'Voice Call (Home Phone)' },
                { type: 'voice-phonecell', label: 'Voice Call (Cell Phone)' }
            ];
        }
    };
})
    .directive('strategiesForm', ['jobService', function (jobService) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, elem, attrs) {
                scope.$watch('recallsStrategies.$valid', function () {
                    jobService.job.isValid = scope.recallsStrategies.$valid;
                });
            }
        };
    }]);
//# sourceMappingURL=communications-strategies.js.map